import { lookup, onboarding } from '../../../../lib/apiList'
import axios from '../../../../lib/axios'

export const getLocations = (): Promise<any> => {
    return axios.post(lookup.GETLOCATIONS, {})
}

export const getRoles = (): Promise<any> => {
    return axios.get(lookup.ROLES)
}

export const getLookupValues = (): Promise<any> => {
    return axios.get(lookup.LOOKUPUSER)
}

export const getLeavePolicy = (): Promise<any> => {
    return axios.post(lookup.LEAVEPOLICY, {})
}

export const createUser = (data: any): Promise<any> => {
    return axios.post(onboarding.USERONBOARDING, data)
}

export const getUserLocationbased = (id: string): Promise<any> => {
    return axios.get(`${onboarding.GETLOCBASEDMANGER}=${id}`)
}
